import {useTranslation} from 'react-i18next';
import * as css from './PromotionExplain.css';

const LAYERS = ['Exposure', 'Effectiveness', 'Financial'] as const;

const PromotionExplain = () => {
    const {t} = useTranslation('realtime');
    return (
        <css.explainContent>
            <css.explainTitle>{t('promotionExplainTitle')}</css.explainTitle>
            <css.explainIntro>{t('promotionExplainIntro')}</css.explainIntro>
            <css.explainLayers>
                {LAYERS.map(key => (
                    <css.explainLine key={key}>
                        <b>{t(`promotionExplain${key}Label`)}</b> {t(`promotionExplain${key}Text`)}
                    </css.explainLine>
                ))}
            </css.explainLayers>
        </css.explainContent>
    );
};

export default PromotionExplain;
